import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import { useHistory, useLocation } from "react-router-dom";
import {
  HeroBanner,
  ConfirmationRegisterContent,
} from "~/components/sections";
import {
  Header,
  Footer,
  WinnerModal,
  FaileModal
} from "~/components/blocks";
import { Breadcrumb } from "~/components/elements";
import { scrollTo } from "~/utils/tools";
import promoIsActive from "~/utils/promoIsActive";

export default function PromoReg() {
  const history = useHistory();
  const location = useLocation();

  const { ganhou } = location.state || false;

  const [openModalWinner, setOpenModalWinner] = useState(ganhou);
  const [openModalFaile, setFaileModal] = useState(!ganhou);


  useEffect(() => {
    scrollTo(700);

    if (!promoIsActive()) {
      history.push({
        pathname: "/minha-conta"
      });
    }
  }, [history]);

  const transition = {
    duration: 0.3,
    ease: [0.43, 0.13, 0.23, 0.96],
  };

  const animations = {
    exit: { y: "50%", opacity: 0, transition },
    enter: {
      y: "0%",
      opacity: 1,
      transition,
    },
  };

  const navBreadcrumb = [
    {
      text: "Minha conta",
      link: "/minha-conta",
    },
    {
      text: "Registrar Compra",
      link: "/cadastro-promo/sucesso",
    },
  ];

  const handleModalWinner = (data) => {
    setOpenModalWinner(data);
  };

  const handleModalFaile = (data) => {
    setFaileModal(data);
  };

  return (
    <>
      <Helmet>
        <title>Participe da promoção | Bebê Johnson's</title>
      </Helmet>
      <Header />
      <WinnerModal
        openModal={openModalWinner}
        handleModalWinner={handleModalWinner}
      />

      <FaileModal
        openModal={openModalFaile}
        handleModal={handleModalFaile}      
      />

      <motion.div
        variants={animations}
        className="single"
        initial="exit"
        animate="enter"
        exit="exit"
      >
        <HeroBanner />
        <Breadcrumb navBreadcrumb={navBreadcrumb} />
        <ConfirmationRegisterContent step={3} />
      </motion.div>
      <Footer />
    </>
  );
}
